import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from "react-router-dom";
import "./NavMenu.css"; 
import { auth } from "../../../firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import RecentViews from "../recents/RecentView";
import AccountMenu from "./AccountMenu";

export default function NavMenu() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [userID, setUserID] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserID(user.uid);
      } else {
        console.log("No user is signed in.");
        setUserID(null);
      }
    });
    return () => unsubscribe();
  }, []);

  const toggleDrawer = (open) => () => {
    setIsDrawerOpen(open);
  };

  const handleNavigate = () => {
    setTimeout(() => {
      setIsDrawerOpen(false);
    }, 100);
  };
  
  return (
    <div>
      <div onClick={toggleDrawer(true)} className="nav-menu-icon" >
        <MenuIcon sx={{ color: 'var(--Grey6)' }} />
      </div>

      <div
        className={`nav-menu-overlay ${isDrawerOpen ? 'open' : ''}`}
        onClick={toggleDrawer(false)}
      ></div>
      
      <div className={`nav-menu ${isDrawerOpen ? 'open' : ''}`}>
        <ul className="nav-menu-list">
          <li className="nav-menu-item">
            <Link to="/home" onClick={handleNavigate}>
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24" style={{ verticalAlign: 'middle', margin: '0 8px 0 0px', width: '20px', height: '20px' }}><path fill="var(--Grey6)" d="M23.5,11.3L12.6,2.7c-.2-.1-.3-.2-.5-.2s-.3,0-.5.2L.5,11.3c-.3.3-.4.9-.2,1.2.3.3.9.4,1.2,0l1.8-1.4v9.4c0,.4.4.9.9.9h5.5c.4,0,.9-.4.9-.9v-3.5c0-.8.7-1.4,1.4-1.4s1.4.7,1.4,1.4v3.5c0,.4.4.9.9.9h5.5c.4,0,.9-.4.9-.9v-9.4l1.8,1.4c.3.3,1,.2,1.2,0,.2-.3.2-1-.2-1.2h.2ZM18.9,19.8h-3.7v-2.6c0-1.8-1.4-3.2-3.2-3.2s-3.2,1.4-3.2,3.2v2.6h-3.7v-9.9l6.9-5.5,6.9,5.5v9.9Z"/></svg>
              <span style={{ verticalAlign: 'middle' }}>Home</span>
            </Link>
          </li>
          <li className="nav-menu-item">
            <Link to="/views" onClick={handleNavigate}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" style={{ verticalAlign: 'middle', margin: '0 8px 0 0px' }}><path fill="var(--Grey6)" d="M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-7 18H4v-7h10Zm0-9H4V4h10Zm6 9h-4V4h4Z"/></svg>
              <span style={{ verticalAlign: 'middle' }}>Views</span>
          </Link>
          </li>
          <li className="nav-menu-item">
            <Link to="/connectors" onClick={handleNavigate}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" style={{ verticalAlign: 'middle', margin: '0 8px 0 0px' }}><path fill="var(--Grey6)" d="M11 13a1 1 0 1 0 1 1a1 1 0 0 0-1-1m-4 0a1 1 0 1 0 1 1a1 1 0 0 0-1-1m15-9a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v4a3 3 0 0 0 .78 2A3 3 0 0 0 2 12v4a3 3 0 0 0 3 3h6v2H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2h-8v-2h6a3 3 0 0 0 3-3v-4a3 3 0 0 0-.78-2A3 3 0 0 0 22 8Zm-2 12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Zm0-8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Zm-9-3a1 1 0 1 0 1 1a1 1 0 0 0-1-1M7 5a1 1 0 1 0 1 1a1 1 0 0 0-1-1"/></svg>
              <span style={{ verticalAlign: 'middle' }}>Connectors</span>
          </Link>
          </li>
        </ul>
        <div className="nav-menu-divider" />
        <p className="nav-menu-recent-views-title">Recent Views</p>
        <RecentViews isMenu={true} showActions={false} limit={5} onNavigate={handleNavigate} />
      
         
      <AccountMenu />

      </div>


    </div>
  );
}